export default "__VITE_ASSET__CbP3qheU__"